// @flow

import React, { type ElementProps } from "react";
import type { ErrorListProps } from "@rjsf/utils";
import { View, Text } from "@components";
import { capitalizeFirstLetter } from "@utils/string";

type Props = ErrorListProps;

export default function ErrorTemplate(props: Props) {
  function customError(error) {
    if (error.includes("must have required")) {
      const regexRequired = /must have required property ([\D\d\s]+)/;
      return error.replace(regexRequired, "Required");
    } else if (error.includes("must be >=")) {
      const regexRequired = /must be >= ([\D\d\s]+)/;
      return error.replace(regexRequired, "Must be equal or greater than $1");
    } else if (error.includes("must be <=")) {
      const regexRequired = /must be <= ([\D\d\s]+)/;
      return error.replace(regexRequired, "Must be equal or less than $1");
    } else if (error.includes("must match exactly one schema in oneOf")) {
      const regexRequired = /must match exactly one schema in oneOf/;
      return error.replace(regexRequired, "Select a valid value");
    } else if (error.includes("Must be string")) {
      const regexRequired = /Must be string/;
      return error.replace(regexRequired, "Select a valid value");
    }

    return capitalizeFirstLetter(error);
  }
  return (
    props.errors && (
      <View position="relative">
        <Text
          className="error-msg text-danger position-absolute"
          text={customError(props.errors[props.errors.length - 1])}
        />
        {/* Will leave this commented piece of code in case we want
        to bring back the multi messages
        {props.errors.map((error: string, idx: number) => (
          <Text
            key={idx}
            className="error-msg text-danger position-absolute"
            text={customError(error)}
          />
        ))} */}
      </View>
    )
  );
}
